module.exports = __webpack_public_path__ + "static/media/mc_settings_button_invalid.382f8bc9.svg";